export const breakpoints = {
  original: 1920,
  desktop: 1440,
  tablet: 1024,
  mobile: 768
}
